<div class="ir-area ir-mask th-mask">
  <div class="ir-modal th-modal">
    <modal-header
      [plugin]="plugin"
      [menuModal]="menuModal"
      preventDefault="true"
      (menuClick)="openMenu()"
    ></modal-header>
    <div class="ir-modal--body has-footer">
      <div class="ir-content--modal th-content ir-file-manager-content">
        <file-manager
          [nodes]="nodes"
          (toggleOpenFileNode)="openAsset($event)"
          (toggleCreateFolder)="openCreateFolder()"
          (toggleUploadFiles)="uploadFiles($event)"
          (toggleOpenNode)="openFolder($event)"
          (toggleDeleteNodes)="deleteItems($event)"
          [query]="query"
        ></file-manager>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<file-reader #filePreview (confirmOutput)="selectFileBox($event)"></file-reader>
<modal #createFolderModal (modalOutput)="createFolder($event)"></modal>
<modal #createFileBox (modalOutput)="createNewFileBox($event)"></modal>
<confirm
  #deleteFileBoxConfirm
  (confirmOutput)="deleteFileBox()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure you want to delete file box?'"
  [danger]="true"
></confirm>
